import { render, staticRenderFns } from "./StudentLayoutNobar.vue?vue&type=template&id=04b444f7&scoped=true"
import script from "./StudentLayoutNobar.vue?vue&type=script&lang=js"
export * from "./StudentLayoutNobar.vue?vue&type=script&lang=js"
import style0 from "./StudentLayoutNobar.vue?vue&type=style&index=0&id=04b444f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b444f7",
  null
  
)

export default component.exports